// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light;
  font-family: "Segoe UI Variable Display", "Franklin Gothic Medium", "Trebuchet MS", sans-serif;
  --bg-top: #f4efe4;
  --bg-bottom: #d9e7f2;
  --surface: rgba(255, 255, 255, 0.72);
  --surface-strong: #ffffff;
  --text-main: #13293d;
  --text-muted: #54728b;
  --accent: #df6d3d;
  --accent-dark: #b64a1e;
  --line: rgba(19, 41, 61, 0.1);
  --shadow: 0 24px 60px rgba(19, 41, 61, 0.12);
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-height: 100vh;
  background: radial-gradient(circle at top left, #fff8ed 0%, transparent 36%),
    linear-gradient(160deg, var(--bg-top) 0%, var(--bg-bottom) 100%);
  color: var(--text-main);
}

button,
input {
  font: inherit;
}

#root {
  min-height: 100vh;
}

.app-shell {
  min-height: 100vh;
  padding: 40px 24px;
}

.login-shell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-panel,
.content-panel,
.report-table,
.modal-card {
  background: var(--surface);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: var(--shadow);
}

.login-panel {
  width: min(440px, 100%);
  padding: 40px;
  border-radius: 28px;
}

.login-panel h1,
.topbar h1,
.panel-header h2 {
  margin: 0;
}

.subtle-copy,
.dashboard-tile span,
.report-card span {
  color: var(--text-muted);
}

.eyebrow {
  margin: 0 0 8px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.72rem;
  color: var(--accent-dark);
}

.login-form,
.modal-form {
  display: grid;
  gap: 18px;
  margin-top: 24px;
}

.login-form label,
.modal-form label {
  display: grid;
  gap: 8px;
  font-weight: 600;
}

.login-form input,
.modal-form input {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.88);
}

.status-dropdown {
  position: relative;
}

.status-trigger,
.status-option {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--text-main);
}

.status-trigger {
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.status-menu {
  position: absolute;
  z-index: 5;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  display: grid;
  gap: 8px;
}

.status-option {
  padding: 12px 14px;
  text-align: left;
  box-shadow: var(--shadow);
}

.status-option.selected {
  border-color: rgba(223, 109, 61, 0.55);
  background: #fff4ee;
}

.status-copy {
  display: grid;
  gap: 4px;
}

.status-copy strong {
  font-size: 0.98rem;
}

.status-copy small {
  color: var(--text-muted);
  font-family: "Georgia", "Times New Roman", serif;
  font-size: 0.8rem;
  line-height: 1.35;
}

.status-caret {
  color: var(--text-muted);
  font-size: 1rem;
}

.primary-button,
.secondary-button,
.table-button,
.dashboard-tile {
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}

.primary-button {
  padding: 14px 18px;
  background: linear-gradient(135deg, var(--accent) 0%, #ff8f5c 100%);
  color: #fff;
  font-weight: 700;
}

.secondary-button,
.table-button {
  padding: 11px 16px;
  background: rgba(19, 41, 61, 0.08);
  color: var(--text-main);
}

.danger {
  background: rgba(182, 74, 30, 0.14);
  color: var(--accent-dark);
}

.primary-button:hover,
.secondary-button:hover,
.table-button:hover,
.dashboard-tile:hover {
  transform: translateY(-2px);
}

.error-text {
  margin: 0;
  color: #9c2f16;
  font-weight: 600;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 auto 28px;
  max-width: 1180px;
}

.topbar-actions,
.row-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.dashboard-grid {
  max-width: 1180px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.dashboard-tile {
  min-height: 170px;
  padding: 24px;
  text-align: left;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 247, 252, 0.86) 100%);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tile-kicker {
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 0.7rem;
}

.dashboard-tile strong,
.report-card strong {
  font-size: 1.7rem;
}

.content-panel,
.report-table {
  max-width: 1180px;
  margin: 0 auto;
  border-radius: 28px;
  padding: 28px;
}

.reports-layout {
  display: grid;
  gap: 22px;
}

.report-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.report-card {
  background: var(--surface-strong);
  border-radius: 20px;
  padding: 22px;
  box-shadow: inset 0 0 0 1px rgba(19, 41, 61, 0.06);
  display: grid;
  gap: 10px;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.panel-header.compact {
  margin-bottom: 16px;
}

.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 18px;
  overflow: hidden;
}

th,
td {
  padding: 16px;
  text-align: left;
  border-bottom: 1px solid var(--line);
}

th {
  background: rgba(19, 41, 61, 0.05);
}

tbody tr:last-child td {
  border-bottom: none;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(19, 41, 61, 0.25);
  display: grid;
  place-items: center;
  padding: 24px;
}

.modal-card {
  width: min(520px, 100%);
  border-radius: 28px;
  padding: 28px;
}

@media (max-width: 960px) {
  .dashboard-grid,
  .report-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .app-shell {
    padding: 24px 16px;
  }

  .topbar,
  .panel-header {
    flex-direction: column;
    align-items: stretch;
  }

  .dashboard-grid,
  .report-card-grid {
    grid-template-columns: 1fr;
  }

  .login-panel,
  .content-panel,
  .report-table,
  .modal-card {
    padding: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,8FAA8F;EAC9F,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB;oEACkE;EAClE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,mEAAmE;EACnE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,iGAAiG;EACjG,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;;;IAIE,aAAa;EACf;AACF","sourcesContent":[":root {\r\n  color-scheme: light;\r\n  font-family: \"Segoe UI Variable Display\", \"Franklin Gothic Medium\", \"Trebuchet MS\", sans-serif;\r\n  --bg-top: #f4efe4;\r\n  --bg-bottom: #d9e7f2;\r\n  --surface: rgba(255, 255, 255, 0.72);\r\n  --surface-strong: #ffffff;\r\n  --text-main: #13293d;\r\n  --text-muted: #54728b;\r\n  --accent: #df6d3d;\r\n  --accent-dark: #b64a1e;\r\n  --line: rgba(19, 41, 61, 0.1);\r\n  --shadow: 0 24px 60px rgba(19, 41, 61, 0.12);\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  min-height: 100vh;\r\n  background: radial-gradient(circle at top left, #fff8ed 0%, transparent 36%),\r\n    linear-gradient(160deg, var(--bg-top) 0%, var(--bg-bottom) 100%);\r\n  color: var(--text-main);\r\n}\r\n\r\nbutton,\r\ninput {\r\n  font: inherit;\r\n}\r\n\r\n#root {\r\n  min-height: 100vh;\r\n}\r\n\r\n.app-shell {\r\n  min-height: 100vh;\r\n  padding: 40px 24px;\r\n}\r\n\r\n.login-shell {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.login-panel,\r\n.content-panel,\r\n.report-table,\r\n.modal-card {\r\n  background: var(--surface);\r\n  backdrop-filter: blur(16px);\r\n  border: 1px solid rgba(255, 255, 255, 0.6);\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.login-panel {\r\n  width: min(440px, 100%);\r\n  padding: 40px;\r\n  border-radius: 28px;\r\n}\r\n\r\n.login-panel h1,\r\n.topbar h1,\r\n.panel-header h2 {\r\n  margin: 0;\r\n}\r\n\r\n.subtle-copy,\r\n.dashboard-tile span,\r\n.report-card span {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.eyebrow {\r\n  margin: 0 0 8px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.18em;\r\n  font-size: 0.72rem;\r\n  color: var(--accent-dark);\r\n}\r\n\r\n.login-form,\r\n.modal-form {\r\n  display: grid;\r\n  gap: 18px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.login-form label,\r\n.modal-form label {\r\n  display: grid;\r\n  gap: 8px;\r\n  font-weight: 600;\r\n}\r\n\r\n.login-form input,\r\n.modal-form input {\r\n  width: 100%;\r\n  border: 1px solid var(--line);\r\n  border-radius: 14px;\r\n  padding: 14px 16px;\r\n  background: rgba(255, 255, 255, 0.88);\r\n}\r\n\r\n.status-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.status-trigger,\r\n.status-option {\r\n  width: 100%;\r\n  border: 1px solid var(--line);\r\n  border-radius: 14px;\r\n  background: rgba(255, 255, 255, 0.92);\r\n  color: var(--text-main);\r\n}\r\n\r\n.status-trigger {\r\n  padding: 14px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.status-menu {\r\n  position: absolute;\r\n  z-index: 5;\r\n  top: calc(100% + 8px);\r\n  left: 0;\r\n  right: 0;\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.status-option {\r\n  padding: 12px 14px;\r\n  text-align: left;\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.status-option.selected {\r\n  border-color: rgba(223, 109, 61, 0.55);\r\n  background: #fff4ee;\r\n}\r\n\r\n.status-copy {\r\n  display: grid;\r\n  gap: 4px;\r\n}\r\n\r\n.status-copy strong {\r\n  font-size: 0.98rem;\r\n}\r\n\r\n.status-copy small {\r\n  color: var(--text-muted);\r\n  font-family: \"Georgia\", \"Times New Roman\", serif;\r\n  font-size: 0.8rem;\r\n  line-height: 1.35;\r\n}\r\n\r\n.status-caret {\r\n  color: var(--text-muted);\r\n  font-size: 1rem;\r\n}\r\n\r\n.primary-button,\r\n.secondary-button,\r\n.table-button,\r\n.dashboard-tile {\r\n  border: none;\r\n  border-radius: 16px;\r\n  cursor: pointer;\r\n  transition: transform 160ms ease, box-shadow 160ms ease, background-color 160ms ease;\r\n}\r\n\r\n.primary-button {\r\n  padding: 14px 18px;\r\n  background: linear-gradient(135deg, var(--accent) 0%, #ff8f5c 100%);\r\n  color: #fff;\r\n  font-weight: 700;\r\n}\r\n\r\n.secondary-button,\r\n.table-button {\r\n  padding: 11px 16px;\r\n  background: rgba(19, 41, 61, 0.08);\r\n  color: var(--text-main);\r\n}\r\n\r\n.danger {\r\n  background: rgba(182, 74, 30, 0.14);\r\n  color: var(--accent-dark);\r\n}\r\n\r\n.primary-button:hover,\r\n.secondary-button:hover,\r\n.table-button:hover,\r\n.dashboard-tile:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.error-text {\r\n  margin: 0;\r\n  color: #9c2f16;\r\n  font-weight: 600;\r\n}\r\n\r\n.topbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  margin: 0 auto 28px;\r\n  max-width: 1180px;\r\n}\r\n\r\n.topbar-actions,\r\n.row-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.dashboard-grid {\r\n  max-width: 1180px;\r\n  margin: 0 auto;\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.dashboard-tile {\r\n  min-height: 170px;\r\n  padding: 24px;\r\n  text-align: left;\r\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 247, 252, 0.86) 100%);\r\n  box-shadow: var(--shadow);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.tile-kicker {\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.16em;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.dashboard-tile strong,\r\n.report-card strong {\r\n  font-size: 1.7rem;\r\n}\r\n\r\n.content-panel,\r\n.report-table {\r\n  max-width: 1180px;\r\n  margin: 0 auto;\r\n  border-radius: 28px;\r\n  padding: 28px;\r\n}\r\n\r\n.reports-layout {\r\n  display: grid;\r\n  gap: 22px;\r\n}\r\n\r\n.report-card-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 18px;\r\n}\r\n\r\n.report-card {\r\n  background: var(--surface-strong);\r\n  border-radius: 20px;\r\n  padding: 22px;\r\n  box-shadow: inset 0 0 0 1px rgba(19, 41, 61, 0.06);\r\n  display: grid;\r\n  gap: 10px;\r\n}\r\n\r\n.panel-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.panel-header.compact {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: rgba(255, 255, 255, 0.72);\r\n  border-radius: 18px;\r\n  overflow: hidden;\r\n}\r\n\r\nth,\r\ntd {\r\n  padding: 16px;\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\nth {\r\n  background: rgba(19, 41, 61, 0.05);\r\n}\r\n\r\ntbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(19, 41, 61, 0.25);\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 24px;\r\n}\r\n\r\n.modal-card {\r\n  width: min(520px, 100%);\r\n  border-radius: 28px;\r\n  padding: 28px;\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .dashboard-grid,\r\n  .report-card-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .app-shell {\r\n    padding: 24px 16px;\r\n  }\r\n\r\n  .topbar,\r\n  .panel-header {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .dashboard-grid,\r\n  .report-card-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .login-panel,\r\n  .content-panel,\r\n  .report-table,\r\n  .modal-card {\r\n    padding: 22px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
